import React from 'react';
import { Container, Row } from 'reactstrap';
import FindMoreSkeleton from '@/components/Grids/FindMore/FindMoreSkeleton';
const Skeleton = () => {
  // Top picks grid loop data
  const skeletonRelated = [{
    id: 1
  }, {
    id: 2
  }];
  return <>
   <div className="fulfillment-panel skeleton-section">
    <div className="DownloadStarted_download-banner-comp skeleton-loading banners download-banner container">
     <h1 className="skeleton-title"></h1>
     <div data-bdd="singleitem-row" className="banner-singlecard row">
      <div className="card-deck">
       <div className="singleitem-card card">
        <div className="col-sm-12 col-lg-3 skeleton-image"></div>
        <div className="col-sm-12 col-lg-9">
         <div className="card-body card-body">
          <div className="card-title-skeleton"></div>
          <p className="card-text-skeleton"> </p>
          <div className="card-footer-skeleton"></div>
         </div>
        </div>
       </div>
      </div>
     </div>
     <div className="DownloadStarted_view-asset__bdh4B row">
      <div className={'col-md-12'}>
       <div className={'DownloadStarted-text-skeleton'}></div>
      </div>
     </div>
    </div>
    <Container className={'section-dividers'} data-sentry-element="Container" data-sentry-source-file="fulfillmentSkeleton.tsx">
     <hr />
    </Container>
    <div className="DownloadStarted_download-related banners download-banner skeleton-loading container">
     <h1 className="skeleton-title"></h1>
     <div data-bdd="singleitem-row" className="banner-singlecard row">
      <div className="card-deck">
       <div className="singleitem-card card">
        <div className="col-sm-12 col-lg-4 skeleton-image"></div>
        <div className="col-sm-12 col-lg-8">
         <div className="card-body card-body">
          <div className="card-type-skeleton"></div>
          <div className="card-title-skeleton"></div>
          <p className="card-text-skeleton"> </p>
          <div className="card-footer">
           <a className="tt-button-med-skeleton"></a>
           <span className="download-button-text-skeleton"> </span>
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
    <Container className={'section-dividers'} data-sentry-element="Container" data-sentry-source-file="fulfillmentSkeleton.tsx">
     <hr />
    </Container>
    <div className="DownloadStarted_download-related banners download-banner skeleton-loading container">
     <h1 className="skeleton-title"></h1>
     <div data-bdd="singleitem-row" className="banner-singlecard row">
      {skeletonRelated?.map(({
            id
          }, index) => <div className={`card-deck`} key={`card-deck-` + id + index}>
        <div className="singleitem-card card">
         <div className="col-sm-12 col-lg-4 skeleton-image"></div>
         <div className="col-sm-12 col-lg-8">
          <div className="card-body card-body">
           <div className="card-type-skeleton"></div>
           <div className="card-title-skeleton"></div>
           <p className="card-text-skeleton"> </p>
           <div className="card-footer">
            <a className="tt-button-med-skeleton"></a>
            <span className="download-button-text-skeleton"> </span>
           </div>
          </div>
         </div>
        </div>
       </div>)}
     </div>
    </div>
    <Container className={'section-dividers'} data-sentry-element="Container" data-sentry-source-file="fulfillmentSkeleton.tsx">
     <hr />
    </Container>
    <Container className={'bottom-download-grid skeleton-loading'} data-sentry-element="Container" data-sentry-source-file="fulfillmentSkeleton.tsx">
     <Row className={'gx-4 skeleton-heading-row'} data-sentry-element="Row" data-sentry-source-file="fulfillmentSkeleton.tsx">
      <h2 className={'section-heading skeleton-grid-heading'} data-bdd={'skeleton-heading_top-picks'} />
     </Row>
     <FindMoreSkeleton data-sentry-element="FindMoreSkeleton" data-sentry-source-file="fulfillmentSkeleton.tsx" />
    </Container>
   </div>
  </>;
};
export default Skeleton;